export async function getDeviceContext() {
  // Production: MaAz Desktop owns the machine identity.
  if (window.maazDesktop?.getDeviceInfo) {
    try {
      const electronDevice = await window.maazDesktop.getDeviceInfo();

      if (electronDevice?.device_id) {
        const device = {
          device_id: String(electronDevice.device_id),
          device_name: String(electronDevice.device_name || "MaAz Desktop"),
        };

        localStorage.setItem("device_id", device.device_id);
        localStorage.setItem("device_name", device.device_name);
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceName");

        return device;
      }
    } catch (error) {
      console.error("Unable to read Electron device identity:", error);

      if (window.maazDesktop?.isElectron) {
        throw new Error(
          "Unable to read this PC device identity. Please restart MaAz Desktop."
        );
      }
    }
  }

  // Development-only browser fallback. The packaged Electron application
  // never treats this value as authoritative.
  let device_id =
    localStorage.getItem("device_id") ||
    localStorage.getItem("deviceId");

  let device_name =
    localStorage.getItem("device_name") ||
    localStorage.getItem("deviceName");

  if (!device_id) {
    device_id =
      window.crypto?.randomUUID?.() ||
      `browser-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    localStorage.setItem("device_id", device_id);
  }

  if (!device_name) {
    device_name = `${navigator.platform || "Unknown Platform"} - ${
      navigator.userAgent || "Unknown Browser"
    }`;

    localStorage.setItem("device_name", device_name);
  }

  return { device_id, device_name };
}
